import React from 'react';
import { Field } from '../../gs-component-form';

const isInternationalPhone = (number: string) => /^\+/.test(number);

const usPhoneFormat = (digits: string): string => {
  if (digits.length > 3 && digits.length <= 6) {
    return digits.replace(/^(\d{3})(\d{1,3})$/, '$1-$2');
  } else if (digits.length > 6 && digits.length <= 10) {
    return digits.replace(/^(\d{3})(\d{3})(\d{1,4})$/, '$1-$2-$3');
  }
  return digits;
};

const formatPhone = function(fieldValue: string): string {
  if (!fieldValue) return '';
  const digits = fieldValue.replace(/\D/g, '');
  if (isInternationalPhone(fieldValue)) return `+${digits}`;
  return usPhoneFormat(digits);
};

const FormattedPhoneNumber = (props: any) => {
  const newProps = { ...props, field: { ...props.field, value: formatPhone(props.field.value) } };
  return <Field {...newProps} maxLength={isInternationalPhone(props.field.value) ? 16 : 12} />;
};

export default FormattedPhoneNumber;
